import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { clubAPI, vaultAPI } from '../services/api';
import CardCapture from './CardCapture';
import './ClubFund.css';

function ClubSubscription() {
  const { clubId } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => { loadData(); }, [clubId]);

  const loadData = async () => {
    setLoading(true);
    try {
      const result = await clubAPI.getClubSubscription(clubId);
      if (result.success) setData(result);
    } catch (err) { /* ignore */ }
    setLoading(false);
  };

  if (loading) return <div><p style={{ color: '#666' }}>Loading...</p></div>;

  return (
    <div>
      <h2>Club Subscription</h2>

      {data?.club && (
          <div className="balance-cards">
            <div className="balance-card kitty">
              <div className="balance-label">Contribution Amount</div>
              <div className="balance-amount">${data.club.contributionAmount?.toFixed(2)}</div>
            </div>
            <div className="balance-card betting">
              <div className="balance-label">Frequency</div>
              <div className="balance-amount" style={{ fontSize: '1.2rem', textTransform: 'capitalize' }}>{data.club.contributionFrequency}</div>
            </div>
          </div>
        )}

        {data?.subscription ? (
          <div className="fund-form">
            <h3 style={{ color: '#fff', marginBottom: '1rem' }}>Your Subscription</h3>
            <div style={{ display: 'grid', gap: '0.75rem' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span style={{ color: '#999' }}>Status</span>
                <span style={{ color: data.subscription.state === 'active' ? '#10b981' : '#fbbf24', fontWeight: 600, textTransform: 'uppercase' }}>{data.subscription.state}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span style={{ color: '#999' }}>Amount</span>
                <span style={{ color: '#fff' }}>${data.subscription.amount?.toFixed(2)}</span>
              </div>
              {data.subscription.nextAssessmentDate && (
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span style={{ color: '#999' }}>Next Payment</span>
                  <span style={{ color: '#fff' }}>{new Date(data.subscription.nextAssessmentDate).toLocaleDateString()}</span>
                </div>
              )}
              {data.subscription.failedAttempts > 0 && (
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span style={{ color: '#999' }}>Failed Attempts</span>
                  <span style={{ color: '#ef4444' }}>{data.subscription.failedAttempts}</span>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="fund-form">
            <p style={{ color: '#999' }}>No active subscription. Add a payment card below to start your subscription.</p>
          </div>
        )}

        <div style={{ marginTop: '1.5rem' }}>
          <h3 style={{ color: '#fff', marginBottom: '0.75rem' }}>Payment Card</h3>
          <CardCapture clubId={clubId} onSuccess={loadData} />
        </div>

        {data?.card?.hasCard && (
          <div className="fund-form" style={{ marginTop: '1rem' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
              <i className="fas fa-credit-card" style={{ color: '#3b82f6', fontSize: '1.3rem' }}></i>
              <div>
                <div style={{ color: '#fff', fontWeight: 600 }}>**** **** **** {data.card.lastFour}</div>
                {data.card.expiry && <div style={{ color: '#666', fontSize: '0.8rem' }}>Expires {data.card.expiry}</div>}
              </div>
            </div>
          </div>
      )}
    </div>
  );
}

export default ClubSubscription;
